import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../controls";
import { EmailAddress } from "../../../emailTopics/models/EmailAddress";

type Props = {
	setAddressSelected: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setShowEditModal: Function;
};

export const useEmailAddressesOptionsFunctions = ({
	setAddressSelected,
	setShowDeleteModal,
	setShowCreateModal,
	setShowEditModal,
}: Props) => {
	const getMenuOptions = (data: EmailAddress) => {
		const newOption: MenuOptionType = {
			name: "New Address",
			key: "new_address",
			onClick: () => {
				setShowCreateModal(true);
			},
			icon: <PlaylistAddIcon />,
		};

		if (!data) return [newOption];

		return [
			newOption,
			{
				name: "Edit Address",
				key: "edit_address",
				onClick: () => {
					setAddressSelected(data);
					setShowEditModal(true);
				},
				icon: <EditIcon />,
			},
			{
				name: "Delete Address",
				key: "delete_address",
				onClick: () => {
					setAddressSelected(data);
					setShowDeleteModal(true);
				},
				icon: <DeleteIcon />,
			},
		] as MenuOptionType[];
	};

	return { getMenuOptions };
};
